/**
 * WHAT EACH MARCADORA IS, in one line. The NAMES are trademarks and are not translated;
 * what is translated is what sets each one apart.
 */
export default {
  kriss: 'Compact SMG, folding stock.',
  smg9: 'SMG with suppressor and optic rail.',
  m4: 'Modern carbine, rail and optic.',
  ak47: 'Classic assault rifle, wood.',
  fn502: 'Pistol. It is the SIDEARM — swap with N.',
  snipper: 'Bolt action with scope. The R5 brings it.',
  side_now: 'Right now it is the {marker}. If they move you, it changes with you.',
  side_any: 'Whatever the field issues your side.',
};
